module.exports = __webpack_public_path__ + "img/user-tick.f614bc08.svg";